import { render, staticRenderFns } from "./categorylevels.vue?vue&type=template&id=63a683a8&scoped=true&"
import script from "./categorylevels.vue?vue&type=script&lang=js&"
export * from "./categorylevels.vue?vue&type=script&lang=js&"
import style0 from "./categorylevels.vue?vue&type=style&index=0&id=63a683a8&lang=scss&scoped=true&"
import style1 from "./categorylevels.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a683a8",
  null
  
)

export default component.exports